<template>
  <!-- <div class="footer"></div> -->
  <div
    class="footer"
    :style="{
      'background-color':
        $route.name == 'Uc'
          ? '#F4F0E8'
          : $route.name == 'bookDetail'
          ? '#eff2f5'
          : '#F4F0E8',
    }"
  >
    <!--    <ul class="banquan">-->
    <!--      <li>反饋意見：digital2@pup.cn</li>-->
    <!--      <li>-->
    <!--        <a target="_blank" href="https://beian.miit.gov.cn/">-->
    <!--          <span>京ICP備09072562號-4</span>-->
    <!--        </a>-->
    <!--      </li>-->
    <!--      <li>京公網安備 11010802040939號</li>-->
    <!--    </ul>-->
    <p class="tuijian">（推荐使用Chrome/edge浏览器）</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDrawer: false,
      // list: [{
      //   path: '/',
      //   title: '首頁'
      // }, {
      //   path: '/show',
      //   title: '映像-書影'
      // }, {
      //   path: '/dddd',
      //   title: '尋蹤-書目'
      // }, {
      //   path: '/analysis',
      //   title: '文本分析'
      // }, {
      //   path: '/ddddd',
      //   title: '大仓故事'
      // }]
    }
  },
  created: function () {

  },
  methods: {
    showMenu () {
      this.showDrawer = true
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  /* border-top: 4px solid #AA1D1F;
    background: url(../../static/home/footer_bg.png) 100% no-repeat;
    height: 50px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center; */
  width: 100%;
  // padding-bottom: 20px;
}
.banquan {
  display: block;
  width: 60%;
  height: 20px;
  display: flex;
  // margin-top: 30px;
  // margin-bottom: 10px;
  margin: 20px auto;
  // justify-content: space-between;
  // align-items: center;
  li {
    width: 33.3%;
    height: 20px;
    display: block;

    font-size: 14px;
    color: #a0a0a0;
    text-align: center;
    font-weight: 700;
    a {
      color: #a0a0a0;
      font-weight: 700;
    }
  }
}
.banquan li:not(:last-child) {
  border-right: 1px solid #a0a0a0;
}
.tuijian {
  text-align: center;
  font-size: 12px;
  color: #a0a0a0;
  font-weight: 700;
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue